module.exports = __webpack_public_path__ + "static/media/Volex_bild_undersida9.663d1325.jpg";